module.exports = __webpack_public_path__ + "static/media/Rectangle 12887.91c9b31a.png";